import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import MultiCarousel from 'react-multi-carousel';
import imgFallback from 'src/utils/image';
import SectionHeader from '../SectionHeader/SectionHeader';
import { classNames } from 'src/utils/helpers';

const responsive = {
  desktop: {
    breakpoint: { max: 9999, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function SimpleCarousel({ isDark, images, sectionHeader: { title, tagline, description } }) {
  const ref = useRef();

  return (
    <Container
      fluid
      as="section"
      className={classNames('py-5', {
        'dark-mode bg-gray-800 py-7': isDark,
      })}
    >
      <SectionHeader title={title} tagline={tagline} description={description} isDark={isDark} />

      <Container fluid>
        <Row>
          <Col xs={12} className="carousel-container position-relative mt-5 px-0">
            <MultiCarousel
              responsive={responsive}
              infinite
              pauseOnHover
              itemClass="slide-item"
              draggable
              swipeable
              keyBoardControl
              ref={ref}
              showDots
              renderDotsOutside
              arrows={false}
              centerMode
            >
              {images &&
                images.map((image, index) => (
                  <Col key={index} xs={12} className="flicker-bugfix px-0">
                    <Col className="carousel-image-container">
                      <GatsbyImage
                        image={image?.image?.asset?.gatsbyImageData ?? imgFallback}
                        alt={image?.alt ?? ''}
                        className="fade-in-lottie"
                      />
                    </Col>
                  </Col>
                ))}
            </MultiCarousel>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

SimpleCarousel.propTypes = {
  isDark: PropTypes.bool,
  images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sectionHeader: PropTypes.shape({
    title: PropTypes.string.isRequired,
    tagline: PropTypes.string,
    description: PropTypes.string,
  }),
};

SimpleCarousel.defaultProps = {
  isDark: false,
  sectionHeader: {
    title: '',
    tagline: '',
    description: '',
  },
};

export default SimpleCarousel;
